import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';



const defaultLocation = {
    lat: 8.5241, // South Kerala
    lng: 76.9366
};

interface MapLocationPickerProps {
    defaultLat?: number;
    defaultLng?: number;
    onChange: (lat: number, lng: number) => void;
}

const MapLocationPicker: React.FC<MapLocationPickerProps> = ({ defaultLat, defaultLng, onChange }) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || "", // Using env variable
    });

    const [markerPosition, setMarkerPosition] = useState<{ lat: number, lng: number } | null>(
        defaultLat && defaultLng ? { lat: defaultLat, lng: defaultLng } : null
    );

    const [mapCenter, setMapCenter] = useState(
        defaultLat && defaultLng ? { lat: defaultLat, lng: defaultLng } : defaultLocation
    );

    useEffect(() => {
        if (defaultLat && defaultLng) {
            setMarkerPosition({ lat: defaultLat, lng: defaultLng });
            setMapCenter({ lat: defaultLat, lng: defaultLng });
        }
    }, [defaultLat, defaultLng]);

    const handleMapClick = (event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setMarkerPosition({ lat, lng });
            onChange(lat, lng);
        }
    };

    const handleMarkerDragEnd = (event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setMarkerPosition({ lat, lng });
            onChange(lat, lng);
        }
    };

    if (!isLoaded) {
        return <div>Loading map...</div>;
    }

    return (
        <div style={{ width: '100%', height: '300px', border: '2px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', position: 'relative', backgroundColor: '#f8f9fa' }}>
            <GoogleMap
                mapContainerStyle={{ width: '100%', height: '100%' }}
                center={mapCenter}
                zoom={defaultLat && defaultLng ? 15 : 9}
                onClick={handleMapClick}
                options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                }}
            >
                {markerPosition && (
                    <Marker
                        position={markerPosition}
                        draggable={true}
                        onDragEnd={handleMarkerDragEnd}
                    />
                )}
            </GoogleMap>
        </div>
    );
};

export default MapLocationPicker;
